import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-public',
  templateUrl: './layout-public.component.html',
  host: { class: 'd-flex flex-column vh-100' } // Styles needed for layout
})
export class LayoutPublicComponent {
}
